var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 647,
    height: 536,
    viewBox: "0 0 647 536",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278.317 155.563C321.274 155.563 356.098 120.739 356.098 77.7814C356.098 34.8239 321.274 0 278.317 0C235.359 0 200.535 34.8239 200.535 77.7814C200.535 120.739 235.359 155.563 278.317 155.563Z",
    fill: "#D7D9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M434.37 228.429H270.382C264.08 228.429 258.973 223.32 258.973 217.02V88.1571C258.973 81.8558 264.081 76.748 270.382 76.748H434.37C440.672 76.748 445.779 81.8564 445.779 88.1571V217.02C445.779 223.32 440.671 228.429 434.37 228.429Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336.817 103.309C308.987 103.309 286.426 125.869 286.426 153.699C286.426 169.503 293.703 183.605 305.087 192.844L336.817 153.699V103.309Z",
    fill: "#59DEEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M387.207 153.699C387.207 125.87 364.647 103.309 336.816 103.309V153.699L347.578 202.934C370.237 198.004 387.207 177.836 387.207 153.699Z",
    fill: "#24605A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M305.086 192.843C313.749 199.874 324.789 204.09 336.816 204.09C340.51 204.09 344.11 203.689 347.578 202.934L336.816 153.699L305.086 192.843Z",
    fill: "#FFD9A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M336.816 103.309V153.699L377.434 183.521",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M404.564 116.002H366.621V123.442H404.564V116.002Z",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M416.966 166.84H379.023V174.28H416.966V166.84Z",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M395.887 131.874H420.19",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M395.887 136.833H420.19",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M395.887 141.793H420.19",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M395.887 183.521H420.19",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M395.887 188.482H420.19",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M395.887 193.442H420.19",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M248.365 319.321H215.117V325.841H248.365V319.321Z",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M242.873 311.532H220.608C217.575 311.532 215.117 309.073 215.117 306.04V292.379C215.117 289.346 217.576 286.888 220.608 286.888H242.873C245.906 286.888 248.364 289.347 248.364 292.379V306.04C248.364 309.073 245.905 311.532 242.873 311.532Z",
    fill: "#24605A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M215.117 332.317H236.413",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M215.117 336.663H236.413",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M215.117 341.009H236.413",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M262.953 368.9H22.5151C16.2569 368.9 11.1836 363.827 11.1836 357.568V216.205C11.1836 209.946 16.2569 204.873 22.5151 204.873H262.953C269.211 204.873 274.285 209.946 274.285 216.205V357.569C274.285 363.827 269.211 368.9 262.953 368.9Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M195.91 204.873V368.9",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M165.188 204.873V368.9",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M134.461 204.873V368.9",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M103.742 204.873V368.9",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0117 204.873V368.9",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2852 204.873V368.9",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1836 307.451L38.9935 289.066C40.9827 287.751 43.5726 287.785 45.526 289.153L66.0688 303.538C68.9985 305.59 73.0689 304.53 74.6262 301.31L97.3761 254.264C99.6633 249.533 106.558 250.032 108.14 255.042L129.939 324.067C131.538 329.128 138.529 329.568 140.75 324.748L160.962 280.873C162.836 276.805 168.416 276.301 170.988 279.968L195.912 315.502",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9254 276.223C90.9254 278.652 88.9568 280.62 86.5291 280.62C84.1014 280.62 82.1328 278.651 82.1328 276.223C82.1328 273.796 84.1014 271.827 86.5291 271.827C88.9568 271.827 90.9254 273.796 90.9254 276.223Z",
    fill: "#59DEEB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3822 269.86L73.8795 263.204H27.1755C24.6041 263.204 22.5195 261.12 22.5195 258.548V238.53C22.5195 235.959 24.6041 233.874 27.1755 233.874H79.0415C81.6129 233.874 83.6974 235.959 83.6974 238.53V263.204V268.509C83.6981 270.242 81.5937 271.1 80.3822 269.86Z",
    fill: "#FFD9A6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 350.089H16.146",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 328.664H16.146",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 307.235H16.146",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 285.81H16.146",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 264.383H16.146",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 242.956H16.146",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 221.529H16.146",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M152.136 307.877C156.569 307.877 160.163 304.283 160.163 299.85C160.163 295.417 156.569 291.823 152.136 291.823C147.703 291.823 144.109 295.417 144.109 299.85C144.109 304.283 147.703 307.877 152.136 307.877Z",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M274.282 216.674H195.91",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M337.024 427.842H274.491C266.549 427.842 260.109 421.403 260.109 413.46V366.109C260.109 358.167 266.549 351.728 274.491 351.728H337.024C344.967 351.728 351.406 358.167 351.406 366.109V413.46C351.406 421.403 344.968 427.842 337.024 427.842Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M283.196 365.584C283.196 364.161 282.043 363.007 280.62 363.007C279.197 363.007 278.043 364.161 278.043 365.584C278.043 367.006 279.197 368.16 280.62 368.16C282.043 368.16 283.196 367.006 283.196 365.584Z",
    fill: "#FFA33E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M299.755 365.584C299.755 364.161 298.601 363.007 297.178 363.007C295.755 363.007 294.602 364.161 294.602 365.584C294.602 367.006 295.755 368.16 297.178 368.16C298.602 368.16 299.755 367.006 299.755 365.584Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M316.314 365.584C316.314 364.161 315.16 363.007 313.737 363.007C312.313 363.007 311.16 364.161 311.16 365.584C311.16 367.006 312.314 368.16 313.737 368.16C315.16 368.16 316.314 367.006 316.314 365.584Z",
    fill: "#59DEEB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M332.864 365.584C332.864 364.161 331.711 363.007 330.288 363.007C328.865 363.007 327.711 364.161 327.711 365.584C327.711 367.006 328.864 368.16 330.288 368.16C331.711 368.16 332.864 367.006 332.864 365.584Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M283.196 381.42C283.196 379.998 282.043 378.844 280.62 378.844C279.197 378.844 278.043 379.997 278.043 381.42C278.043 382.843 279.197 383.997 280.62 383.997C282.043 383.997 283.196 382.843 283.196 381.42Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M299.755 381.42C299.755 379.998 298.601 378.844 297.178 378.844C295.755 378.844 294.602 379.997 294.602 381.42C294.602 382.843 295.755 383.997 297.178 383.997C298.602 383.997 299.755 382.843 299.755 381.42Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M316.314 381.42C316.314 379.998 315.16 378.844 313.737 378.844C312.313 378.844 311.16 379.997 311.16 381.42C311.16 382.843 312.314 383.997 313.737 383.997C315.16 383.997 316.314 382.843 316.314 381.42Z",
    fill: "#24605A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M332.864 381.42C332.864 379.998 331.711 378.844 330.288 378.844C328.865 378.844 327.711 379.997 327.711 381.42C327.711 382.843 328.864 383.997 330.288 383.997C331.711 383.997 332.864 382.843 332.864 381.42Z",
    fill: "#FFA33E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M283.196 397.256C283.196 395.834 282.043 394.68 280.62 394.68C279.197 394.68 278.043 395.834 278.043 397.256C278.043 398.679 279.197 399.833 280.62 399.833C282.043 399.833 283.196 398.679 283.196 397.256Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M299.755 397.256C299.755 395.834 298.601 394.68 297.178 394.68C295.755 394.68 294.602 395.834 294.602 397.256C294.602 398.679 295.755 399.833 297.178 399.833C298.602 399.833 299.755 398.679 299.755 397.256Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M316.314 397.256C316.314 395.834 315.16 394.68 313.737 394.68C312.313 394.68 311.16 395.834 311.16 397.256C311.16 398.679 312.314 399.833 313.737 399.833C315.16 399.833 316.314 398.679 316.314 397.256Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M332.864 397.256C332.864 395.834 331.711 394.68 330.288 394.68C328.865 394.68 327.711 395.834 327.711 397.256C327.711 398.679 328.864 399.833 330.288 399.833C331.711 399.833 332.864 398.679 332.864 397.256Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M283.196 413.095C283.196 411.672 282.043 410.519 280.62 410.519C279.197 410.519 278.043 411.672 278.043 413.095C278.043 414.518 279.197 415.672 280.62 415.672C282.043 415.671 283.196 414.518 283.196 413.095Z",
    fill: "#59DEEB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M299.755 413.095C299.755 411.672 298.601 410.519 297.178 410.519C295.755 410.519 294.602 411.672 294.602 413.095C294.602 414.518 295.755 415.672 297.178 415.672C298.602 415.671 299.755 414.518 299.755 413.095Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M313.737 415.672C315.16 415.672 316.314 414.518 316.314 413.095C316.314 411.672 315.16 410.519 313.737 410.519C312.314 410.519 311.16 411.672 311.16 413.095C311.16 414.518 312.314 415.672 313.737 415.672Z",
    fill: "#FFA33E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M330.292 415.672C331.715 415.672 332.868 414.518 332.868 413.095C332.868 411.672 331.715 410.519 330.292 410.519C328.868 410.519 327.715 411.672 327.715 413.095C327.715 414.518 328.868 415.672 330.292 415.672Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M573.072 224.998H521.098V249.656H573.072V224.998Z",
    fill: "#59DEEB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M521.096 323.021H476.438V347.678H521.096V323.021Z",
    fill: "#59DEEB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M617.729 347.679H573.07V372.336H617.729V347.679Z",
    fill: "#FFA33E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M573.072 274.312H521.098V323.628H573.072V274.312Z",
    fill: "#FFD9A6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M608.191 399.136H485.974C480.707 399.136 476.438 394.866 476.438 389.599V199.189C476.438 193.922 480.707 189.652 485.974 189.652H608.191C613.458 189.652 617.728 193.922 617.728 199.189V389.599C617.728 394.866 613.458 399.136 608.191 399.136Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M521.098 189.652V399.136",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M573.07 189.652V399.136",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M476.438 224.998H617.728",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M476.438 249.655H617.728",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M476.438 274.312H617.728",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M476.438 298.97H617.728",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M476.438 323.627H617.728",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M476.438 348.285H617.728",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M476.438 372.943H617.728",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M623.23 363.606C636.179 360.549 644.197 347.573 641.14 334.624C638.082 321.675 625.106 313.656 612.157 316.714C599.208 319.771 591.19 332.747 594.247 345.696C597.305 358.645 610.281 366.664 623.23 363.606Z",
    fill: "#24605A"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M607.621 343.122L612.374 347.599C613.492 348.651 615.282 348.472 616.169 347.218L627.846 330.69",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M617.728 360.204C628.757 360.204 637.697 351.263 637.697 340.234C637.697 329.205 628.757 320.265 617.728 320.265C606.699 320.265 597.758 329.205 597.758 340.234C597.758 351.263 606.699 360.204 617.728 360.204Z",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M605.419 469.025L597.754 461.36L590.089 469.025L597.754 476.69L605.419 469.025Z",
    fill: "#24605A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M219.907 156.772L212.242 149.107L204.577 156.772L212.242 164.437L219.907 156.772Z",
    fill: "#59DEEB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M577.422 442.707C579.83 440.299 579.83 436.394 577.422 433.986C575.013 431.578 571.109 431.578 568.7 433.986C566.292 436.394 566.292 440.299 568.7 442.707C571.109 445.116 575.013 445.116 577.422 442.707Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M381.98 243.552V345.234",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M432.818 294.394H331.137",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M417.931 258.444L346.031 330.344",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M417.931 330.344L346.031 258.444",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M566.901 130.791V112.322H556.203C555.367 109.15 554.107 106.153 552.494 103.386L560.064 95.8165L547.004 82.7575L539.435 90.3279C536.668 88.7143 533.67 87.4538 530.499 86.6185V75.9209H512.03V86.6185C508.859 87.4545 505.862 88.715 503.094 90.3279L495.525 82.7575L482.465 95.8165L490.036 103.386C488.422 106.153 487.162 109.15 486.327 112.322H475.629V130.791H486.327C487.162 133.962 488.423 136.959 490.036 139.727L482.465 147.296L495.525 160.355L503.094 152.786C505.861 154.399 508.858 155.659 512.03 156.496V167.193H530.499V156.496C533.67 155.66 536.667 154.399 539.435 152.786L547.004 160.355L560.064 147.296L552.494 139.727C554.107 136.959 555.367 133.962 556.203 130.791H566.901ZM521.264 140.827C510.622 140.827 501.994 132.199 501.994 121.556C501.994 110.914 510.622 102.286 521.264 102.286C531.907 102.286 540.535 110.914 540.535 121.556C540.535 132.199 531.907 140.827 521.264 140.827Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M275.298 521.367L263.211 482.54L345.266 465.341L382.124 387.852C387.612 376.318 397.565 367.527 409.684 363.501L422.869 359.118C421.256 367.07 423.307 374.394 435.293 375.867C458.432 378.719 473.91 362.097 478.782 355.949L509.504 371.783C522.563 378.516 530.127 392.603 528.52 407.206L521.599 534.059H378.949L380.46 512.997L379.901 514.184L275.298 521.367Z",
    fill: "#FFA33E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M239.218 534.06H380.43V519.69H239.218V534.06Z",
    fill: "#24605A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M121.117 534.06H281.511L243.402 416.233H83.0078L121.117 534.06Z",
    fill: "#24605A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M280.608 531.277L243.398 416.233",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M178.048 488.764C183.647 487.039 186.491 480.139 184.4 473.353C182.31 466.566 176.076 462.463 170.478 464.188C164.879 465.912 162.035 472.812 164.125 479.599C166.216 486.385 172.449 490.489 178.048 488.764Z",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M378.304 516.998C369.765 525.571 356.333 528.891 344.783 525.283L330.709 525.046L320.658 530.568C318.031 532.18 314.854 532.632 311.882 531.816L305.759 530.133L291.512 521.807L332.567 498.917L374.119 496.362L378.304 516.998Z",
    fill: "#A07252"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M305.762 530.133L325.553 517.612L334.91 516.274",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M299.277 526.877L319.069 514.357L327.809 511.761",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M295.164 523.832L314.956 511.311L323.128 507.495",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M521.596 421.592L475.602 519.692L370.998 526.876L360.727 493.881L440.967 470.847L474.132 408.615L521.596 421.592Z",
    fill: "#FFA33E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M520.849 423.197L486.296 496.894C480.621 509 468.99 517.221 455.684 518.532L371.004 526.877",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M474.132 408.615L440.967 470.847L360.727 493.881",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M412.915 382.16L393.913 427.649C391.112 434.352 390.117 441.672 391.026 448.88L395.224 482.193",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M358.725 462.979L327.633 469.037",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M500.694 340.178C505.156 336.926 509.397 333.166 512.122 328.365C514.847 323.563 515.878 317.557 513.779 312.451C511.843 307.74 507.462 304.126 506.497 299.125C505.374 293.305 509.141 286.743 506.131 281.635C502.937 276.216 494.679 276.731 489.95 272.583C485.83 268.969 484.687 262.073 479.523 260.237C474.676 258.513 469.593 262.5 464.452 262.311C457.018 262.037 451.387 253.237 444.047 254.439C436.974 255.597 434.102 265.211 427.201 267.142C423.629 268.141 419.36 266.926 416.417 269.183C412.817 271.944 413.901 277.598 412.224 281.814C409.629 288.338 400.351 291.401 400.024 298.415C399.798 303.257 404.244 307.356 404.147 312.202C404.092 314.905 402.623 317.357 401.98 319.982C400.188 327.298 404.985 334.602 410.446 339.789C419.541 348.428 431.288 354.13 443.618 356.306C456.663 358.609 468.232 356.039 480.378 351.295C487.588 348.479 494.439 344.739 500.694 340.178Z",
    fill: "#1F245C"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M422.867 359.119L436.834 354.476L440.93 338.884L448.685 309.355H468.845V349.377V350.831L478.779 355.951C473.907 362.099 458.429 378.721 435.29 375.869C423.304 374.395 421.253 367.072 422.867 359.119Z",
    fill: "#A07252"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M421.003 319.584C421.068 322.769 421.759 325.914 423.043 328.835L424.297 331.692L428.099 340.36C430.309 345.396 435.932 347.989 441.197 346.392L450.787 343.481C458.197 341.231 464.233 335.822 467.284 328.706L469.27 324.072L472.773 315.886L473.609 302.693L473.837 299.11C474.594 287.132 466.611 276.342 454.932 273.561L452.071 272.884C443.949 270.953 435.404 273.257 429.362 279.01H429.358C424.67 283.479 421.928 289.604 421.719 296.079L421.008 318.275C420.993 318.713 420.993 319.151 421.003 319.584Z",
    fill: "#A07252"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M462.136 315.397C462.668 322.166 472.659 326.902 479.429 326.369C486.198 325.837 491.254 319.916 490.722 313.146C490.189 306.377 484.269 301.321 477.499 301.854C470.729 302.387 461.602 308.627 462.136 315.397Z",
    fill: "#A07252"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M463.46 334.993C463.46 334.993 460.374 340.568 450.783 343.479L441.191 346.39",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M442.652 314.434C442.652 315.239 443.305 315.891 444.11 315.891C444.914 315.891 445.567 315.239 445.567 314.434C445.567 313.629 444.914 312.977 444.11 312.977C443.305 312.977 442.652 313.629 442.652 314.434Z",
    fill: "#1F245C"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M422.898 313.911C422.898 314.716 423.551 315.369 424.356 315.369C425.16 315.369 425.813 314.716 425.813 313.911C425.813 313.107 425.16 312.454 424.356 312.454C423.551 312.454 422.898 313.107 422.898 313.911Z",
    fill: "#1F245C"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M453.243 331.25C457.071 331.25 460.174 328.147 460.174 324.319C460.174 320.492 457.071 317.389 453.243 317.389C449.415 317.389 446.312 320.492 446.312 324.319C446.312 328.147 449.415 331.25 453.243 331.25Z",
    fill: "#7A563D"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M420.996 319.583C421.061 322.768 421.753 325.913 423.036 328.834L424.29 331.691C425.788 330.422 426.734 328.525 426.734 326.411C426.734 322.986 424.256 320.145 420.996 319.583Z",
    fill: "#7A563D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M429.483 322.438L432.577 319.67L434.152 314.717C434.296 314.264 434.95 314.305 435.037 314.772L436.55 322.96C436.646 323.479 436.279 323.97 435.753 324.025L430.45 324.584C429.263 324.708 428.603 323.245 429.483 322.438Z",
    fill: "#7A563D"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M447.884 322.923C447.884 322.923 443.935 332.116 433.551 329.392",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M475.629 325.96C475.629 324.283 476.989 322.923 478.666 322.923C480.343 322.923 481.703 324.283 481.703 325.96C481.703 327.637 480.343 328.997 478.666 328.997C476.989 328.998 475.629 327.638 475.629 325.96Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M450.884 305.745C447.476 304.394 443.732 303.899 440.09 304.319",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M428.959 304.362C425.958 304.516 422.989 305.249 420.262 306.511",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M416.759 287.651C419.586 290.118 423.347 291.49 427.099 291.423C430.85 291.354 434.6 290.047 437.336 287.478C438.76 290.219 441.254 292.386 444.166 293.414C447.079 294.442 450.366 294.515 453.195 293.275C453.921 297.902 456.245 302.318 459.863 305.294C463.48 308.271 468.401 309.705 473.003 308.831C477.605 307.957 481.751 304.682 483.389 300.293C485.357 295.023 486.069 288.953 483.275 284.07C480.481 279.188 475.087 275.898 469.467 275.65C468.617 272.325 465.381 269.737 462.364 268.102C459.348 266.466 455.914 265.77 452.509 265.346C449.67 264.993 446.784 264.815 443.956 265.246C441.129 265.677 438.346 266.753 436.217 268.663C430.768 268.664 424.89 270.508 420.95 274.273C417.008 278.037 412.654 284.068 416.759 287.651Z",
    fill: "#1F245C"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 534.061H607.614",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M164.164 170.561H86.2999C83.9988 170.561 82.1328 172.426 82.1328 174.728C82.1328 177.029 83.9988 178.895 86.2999 178.895H164.164C166.465 178.895 168.331 177.029 168.331 174.728C168.331 172.426 166.465 170.561 164.164 170.561Z",
    fill: "#FFD9A6"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M607.617 492.193H554.706C552.405 492.193 550.539 494.059 550.539 496.36C550.539 498.662 552.404 500.528 554.706 500.528H607.617C609.919 500.528 611.785 498.662 611.785 496.36C611.785 494.059 609.919 492.193 607.617 492.193Z",
    fill: "#FFD9A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImage);
export default __webpack_public_path__ + "static/media/banner-image.b67e222a3d4556cfeb6d11021d20ec73.svg";
export { ForwardRef as ReactComponent };